import * as AppSettings from './AppSettings';
import * as OrderPad from './OrderPad';
import * as Oidc from './Oidc';
import * as ClientSetup from './ClientSetup';
import * as CustomerSettings from './CustomerSettings';
import * as CurrencySettings from './CurrencySettings';
import { reducer as oidcReducer } from 'redux-oidc';
import { RouterState } from 'connected-react-router';

// The top-level state object
export interface ApplicationState {
  currencySettings: CurrencySettings.CurrencySettingsState;
  appSettings: AppSettings.AppSettingsState;
  orderPad: OrderPad.OrderPadState;
  clientSetup: ClientSetup.ClientSetupState;
  customerSettings: CustomerSettings.CustomerSettingsState;
  oidc: Oidc.OidcState;
  router: RouterState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  oidc: oidcReducer,
  appSettings: AppSettings.reducer,
  orderPad: OrderPad.reducer,
  clientSetup: ClientSetup.reducer,
  customerSettings: CustomerSettings.reducer,
  currencySettings: CurrencySettings.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
